import {MaskState} from "../../interfaces/store/reducers/mask";
import {SetLoadingAction} from "../../interfaces/store/actions/mask";
import {SET_LOADING} from "../actions/availableActions";

const initialState: MaskState = {
    isLoading: false,
};

type AvailableActions = SetLoadingAction;

const maskReducer = (state:MaskState = initialState, action: AvailableActions): MaskState => {
    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                isLoading: action.payload,
            };
        default:
            return state;
    }
};

export default maskReducer;
